/**
 * IMAGE-GALLERY.JS
 *
 * Initialization of image galleries on the page.
 */

import Masonry from "masonry-layout";

export default class ImageGallery {

	/**
	 * Initializes image gallery (if existing) using following libraries:
	 * #masonry-layout
	 * #lightgallery
	 * #imagesLoaded
	 */
	static initAll() {
		return new ImageGallery();
	}

	constructor() {
		const imageGalleries = document.querySelectorAll(".masonry");
		if (imageGalleries.length === 0) return;
	
		imageGalleries.forEach((imageGallery) => {
			const masonry = new Masonry(imageGallery, {
				itemSelector: ".masonry-brick",
				percentPosition: true,
				columnWidth: ".grid-sizer",
				gutter: ".gutter-sizer",
			});
		});
	}
}